import { Directive } from '@angular/core';
import { NG_VALIDATORS, Validator, ValidationErrors, AbstractControl } from '@angular/forms';
import { ValidationsService } from '../../services/validations.service';

@Directive({
  selector: '[appEmailValid]',
  providers: [{ provide: NG_VALIDATORS, useExisting: EmailValidDirective, multi: true }],
})
export class EmailValidDirective implements Validator {
  validate(control: AbstractControl): ValidationErrors | null {
    return ValidationsService.emailValidator()(control);
  }
}
